export default class RouteModel {
  constructor(props: any) {
    // @ts-ignore
    this.key = props.key;
    // @ts-ignore
    this.url = props.url;
    // @ts-ignore
    this.param = props.param;
  }
}
